<template>
<el-card class="box-card" shadow="hover">
  <div slot="header" class="clearfix" style="position:relative">
    <el-breadcrumb>
      <el-breadcrumb-item :to="{ path: 'orderslist' }">订单列表</el-breadcrumb-item>
      <el-breadcrumb-item>订单详情</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
  <div class="text item">
    <el-steps :space="200" :active="form.newstatus" align-center>
      <el-step title="未接单" :description="form.createTime"></el-step>
      <el-step title="已接单" :description="form.receiveTime"></el-step>
      <el-step title="已发货" :description="form.send_end_time"></el-step>
      <el-step title="完成" :description="form.finishTime"></el-step>
    </el-steps>
    <el-form ref="form" :model="form" label-width="160px">
      <el-descriptions class="margin-top" title="订单详情" :column="3" size="medium" border style="margin-top:30px;">
        <template slot="extra">
          <!-- <el-button v-show="(form.sendType==2&&form.pid||form.sendType==1)&&(form.newstatus==3||form.newstatus==4)&&showBtn==5" size="mini" type="primary" plain @click="finishOrder(form.id)">收货</el-button>
          <el-button v-show="(form.sendType==2&&form.pid||form.sendType==1)&&form.newstatus==1&&showBtn==2" size="mini" type="primary" plain @click="ReceiveOrder(form.id)">接单</el-button>
          <el-button v-show="(form.sendType==2&&form.pid||form.sendType==1)&&(form.newstatus==2||form.newstatus==4)&&showBtn!=1" size="mini" type="primary" plain @click="showSend(form.id)">发货</el-button> -->
          <el-button v-show="form.newstatus==5&&showBtn==5" size="mini" plain @click="showService(form.id)">申请售后</el-button>

          <el-popconfirm
            confirm-button-text='好的'
            cancel-button-text='不用了'
            icon="el-icon-info"
            icon-color="red"
            @confirm="delOrders(form.id)" 
            title="确定删除订单吗？"
          >
            <el-button v-if="!form.pid&&(showBtn==0||(form.newstatus==1&&showBtn==1))" size="mini" type="danger" plain slot="reference">删除</el-button>
          </el-popconfirm>
        </template>
        <el-descriptions-item>
          <template slot="label">
            物料编号
          </template>
          {{form.gcode}}
        </el-descriptions-item>
        <el-descriptions-item v-if="form.cgcode">
          <template slot="label">
            客户物料编号
          </template>
          {{form.cgcode}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            物料名称
          </template>
          {{form.title}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            总价
          </template>
          {{form.total}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            单价
          </template>
          {{form.price}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            数量
          </template>
          {{form.num}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            单位
          </template>
          {{form.unit}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            物料描述/规格	
          </template>
          {{form.remark}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            工厂	
          </template>
          {{form.factory}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            库位	
          </template>
          {{form.locator}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            需求来源
          </template>
          {{form.company}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            采购员	
          </template>
          {{form.buyer}}
        </el-descriptions-item>
        <el-descriptions-item v-if="form.sendType==1">
          <template slot="label">
            供应商	
          </template>
          {{form.supplier}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            审核状态	
          </template>
          <p>{{form.examine ? '通过': '不通过'}}</p>
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions class="margin-top" title="发货记录" style="margin-top:30px;">
        </el-descriptions>
        <el-table
          :data="form.log"
          style="width: 100%">
          <el-table-column
            prop="company"
            label="发货公司">
          </el-table-column>
          <el-table-column
            prop="num"
            label="发货数量"
            width="120">
          </el-table-column>
          <el-table-column
            prop="sn"
            label="发货单号">
          </el-table-column>
          <el-table-column
            prop="remark"
            label="备注">
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="时间">
          </el-table-column>
        </el-table>
      
      <el-row v-for="(v , k) in form.orderList" :key="k">
        <el-descriptions class="margin-top" title="子订单详情" :column="3" size="medium" border style="margin-top:30px;">
          <template slot="extra">
            <el-button v-show="(v.sendType==2&&v.pid||v.sendType==1)&&v.newstatus==5&&showBtn==5" size="mini" type="primary" plain @click="finishOrder(v.id)">收货</el-button>
            <el-button v-show="(v.sendType==2&&v.pid||v.sendType==1)&&v.newstatus==2&&showBtn==2" size="mini" type="primary" plain @click="ReceiveOrder(v.id)">接单</el-button>
            <el-button v-show="(v.sendType==2&&v.pid||v.sendType==1)&&v.newstatus==3&&showBtn==2" size="mini" type="primary" plain @click="showSend(v.id)">发货</el-button>
          </template>
          <el-descriptions-item>
            <template slot="label">
              物料编号
            </template>
            {{v.gcode}}
          </el-descriptions-item>
          <el-descriptions-item v-if="v.cgcode">
            <template slot="label">
              客户物料编号
            </template>
            {{v.cgcode}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              物料名称
            </template>
            {{v.title}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              总价
            </template>
            {{v.total}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              单价
            </template>
            {{v.price}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              数量
            </template>
            {{v.num}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              单位
            </template>
            {{v.unit}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              物料描述/规格	
            </template>
            {{v.remark}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              工厂	
            </template>
            {{v.factory}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              采购员	
            </template>
            {{v.purchase}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              库位	
            </template>
            {{v.locator}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              供应商	
            </template>
            {{v.supplier}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              状态	
            </template>
            <p v-if="v.newstatus==1">询价</p>
            <p v-if="v.newstatus==2">未接单</p>
            <p v-if="v.newstatus==3">已接单</p>
            <p v-if="v.newstatus==4">分批发货</p>
            <p v-if="v.newstatus==5">已发货</p>
            <p v-if="v.newstatus==6">已完成</p>
          </el-descriptions-item>
        </el-descriptions>
      </el-row>
    </el-form>
  </div>
  <el-dialog title="发货" label-position="left" :visible.sync="sendBox" width="70%">
    <el-form ref="form" :model="form" label-width="140px">
      <!-- <el-form-item label="发货方式" :required="true">
        <el-radio-group v-model="sendForm.sendType">
          <el-radio :label="0">一次性发货</el-radio>
          <el-radio :label="1">分批发货</el-radio>
        </el-radio-group>
      </el-form-item> -->
      <el-form-item label="物流公司" :required="true">
        <el-input v-model="sendForm.expressCompany" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="送货数量" :required="true">
        <el-input-number v-model="sendForm.expressNum" :min="1" :max="expressNum"></el-input-number>
      </el-form-item>
      <el-form-item label="送货单号" :required="true">
        <el-input v-model="sendForm.expressSn" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input type="textarea" v-model="sendForm.expressRemark" maxlength="150" show-word-limit autocomplete="off"></el-input>
      </el-form-item>
      <el-row>
        <el-divider content-position="left">发货记录</el-divider>
        <el-table
          :data="log"
          style="width: 100%">
          <el-table-column
            prop="company"
            label="发货公司">
          </el-table-column>
          <el-table-column
            prop="num"
            label="发货数量"
            width="120">
          </el-table-column>
          <el-table-column
            prop="sn"
            label="发货单号">
          </el-table-column>
          <el-table-column
            prop="remark"
            label="备注">
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="时间">
          </el-table-column>
        </el-table>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="sendBox = false">取 消</el-button>
      <el-button type="primary" @click="sendOrder">确 定</el-button>
    </div>
  </el-dialog>
  <el-dialog title="收货" label-position="left" :visible.sync="finishBox" width="70%">
    <el-form ref="form" label-width="140px">
      <el-table
        :data="log"
        style="width: 100%">
        <el-table-column
          prop="company"
          label="发货公司">
        </el-table-column>
        <el-table-column
          prop="num"
          label="发货数量"
          width="120">
        </el-table-column>
        <el-table-column
          prop="sn"
          label="发货单号">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注">
        </el-table-column>
        <el-table-column
          label="收货数量">
          <template slot-scope="scope">
            <p v-if="scope.row.reviceTime">{{scope.row.reviceNum}}</p>
            <el-input-number size="mini" v-else v-model="scope.row.reviceNum" :min="0" :max="parseInt(scope.row.num) - parseInt(scope.row.noNum)"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column
          label="退换数量">
          <template slot-scope="scope">
            <p v-if="scope.row.reviceTime">{{scope.row.noNum}}</p>
            <el-input-number size="mini" v-else v-model="scope.row.noNum" :min="0" :max="parseInt(scope.row.num) - parseInt(scope.row.reviceNum)"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="发货时间">
        </el-table-column>
        <el-table-column
          prop="reviceTime"
          label="收货时间">
        </el-table-column>
      </el-table>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="finishBox = false">取 消</el-button>
      <el-button type="primary" @click="finishOrder">确 定</el-button>
    </div>
  </el-dialog>
  <el-dialog title="申请售后" label-position="left" :visible.sync="serviceBox" width="70%">
    <el-form ref="form" label-width="140px">
      <p>发货数量：{{serviceForm.num}}；收货数量：{{serviceForm.num - serviceForm.noNum}}；拒收数量：{{serviceForm.noNum}}；</p>
      <el-form-item label="发货方式" :required="true">
        <el-radio-group v-model="serviceForm.type">
          <el-radio :label="1">退货</el-radio>
          <el-radio :label="2">换货</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="货物数量" :required="true">
        <el-input-number v-model="serviceForm.noNum" :min="1" :max="serviceForm.num"></el-input-number>
      </el-form-item>
      <el-form-item label="联系人" :required="true">
        <el-input v-model="serviceForm.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" :required="true">
        <el-input v-model="serviceForm.phone" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="原因" :required="true">
        <el-input v-model="serviceForm.remark" autocomplete="off" type="textarea" :rows="2"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="serviceBox = false">取 消</el-button>
      <el-button type="primary" @click="serviceOrder">确 定</el-button>
    </div>
  </el-dialog>
</el-card>
</template>
<script>
import orderFunction from "@/api/order"
export default {
  data() {
    return {
      showBtn:sessionStorage.getItem('roleid'),
      sendBox:false,
      finishBox:false,
      serviceBox:false,
      total:0,
      orderBox:false,
      tableLoading:false,
      activeName:"",
      level:[],
      Selectionids:[],
      log:[],
      expressNum:0,
      sendForm:{
        id:'',
        sendType:0,
        expressCompany:'',
        expressNum:0,
        expressSn:'',
        expressRemark:'',
        vcode:sessionStorage.getItem('token'),
      },
      serviceForm:{
        id:'',
        type:1,
        noNum:0,
        num:0,
        reviceNum:0,
        name:'',
        phone:'',
        remark:'',
        vcode:sessionStorage.getItem('token')
      },
      form:{
        id:'',
        company:'',
        buyer:'',
        gcode:'',
        cgcode:'',
        title:'',
        total:'',
        price:'',
        unit:'',
        num:'',
        remark:'',
        factory:'',
        purchase:'',
        locator:'',
        sellerid:'',
        examine:0,
        examineMsg:'',
        sendType:'',
        send_start_time:'',
        send_end_time:'',
        receiveTime:'',
        finishTime:'',
        orderRemark:'',
        createTime:'',
        examineTime:'',
        supplier:'',
        status:1,
        newstatus:1,
        goods:[],
        log:[],
        orderList:[],
        vcode:sessionStorage.getItem('token'),
      },
    };
  },
  methods:{
    getOrder(){
      orderFunction.get(this.form,this).then(res=>{
        this.form.id = res.id
        this.form.gcode = res.gcode
        this.form.company = res.company
        this.form.buyer = res.buyer
        this.form.cgcode = res.cgcode
        this.form.title = res.title
        this.form.total = res.total
        this.form.price = res.price
        this.form.unit = res.unit
        this.form.num = res.num
        this.form.remark = res.remark
        this.form.factory = res.factory
        this.form.purchase = res.purchase
        this.form.locator = res.locator
        this.form.sellerid = res.sellerid
        this.form.examine = res.examine
        this.form.examineMsg = res.examineMsg
        this.form.sendType = res.sendType
        this.form.send_start_time = res.send_start_time
        this.form.send_end_time = res.send_end_time
        this.form.receiveTime = res.receiveTime
        this.form.finishTime = res.finishTime
        this.form.orderRemark = res.orderRemark
        this.form.createTime = res.createTime
        this.form.examineTime = res.examineTime
        this.form.supplier = res.supplier
        this.form.status = res.status
        this.form.newstatus = res.newstatus
        this.form.goods = res.goods
        this.form.log = res.log
        this.form.orderList = res.orderList
      })
    },
    ReceiveOrder(id){
      orderFunction.receive({id:id,vcode:sessionStorage.getItem('token')},this).then(res=>{
        this.getOrder()
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    examineOrder(id){
      orderFunction.examine({id:id,vcode:sessionStorage.getItem('token')},this).then(res=>{
        this.getOrder()
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    delOrders(id){
      var delData = [];
      delData.push(id)
      orderFunction.del({id:delData,vcode:sessionStorage.getItem('token')},this).then(res=>{
        this.$router.push({path: '/home/orderslist'})
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    showSend(id){
      this.sendBox = true
      this.sendForm.id = id
      this.sendForm.sendType = 0
      this.sendForm.expressCompany = ''
      this.sendForm.expressNum = 0
      this.sendForm.expressSn = ''
      this.sendForm.expressRemark = ''
    },
    sendOrder(){
      if(!this.sendForm.expressCompany){
        this.$message.error('物流公司不能为空');
        return false;
      }
      if(!this.sendForm.expressSn){
        this.$message.error('送货单号不能为空');
        return false;
      }
      orderFunction.send(this.sendForm,this).then(res=>{
        this.sendBox=false
        this.getOrder()
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    finishOrder(){
      orderFunction.finish({data:this.log,vcode:sessionStorage.getItem('token')},this).then(res=>{
        this.finishBox=false
        this.getOrder()
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    serviceOrder(){
      orderFunction.service(this.serviceForm,this).then(res=>{
        this.serviceBox=false
        this.getOrder()
      }).catch(err=>{
        this.$message.error(err)
      })
    }
  },
  mounted () {
    this.form.id = this.$route.query.id
    this.getOrder()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/order/editOrder.vue